export default __webpack_public_path__ + "static/media/exclaim.f5b12ef6.svg";